import TableTemplate from "../TableTemplate/TableTemplate";
import styles from "../TableLeftTemplate/TableLeftTemplate.module.css";

interface TableLeftTemplateProps {
  left: React.ReactNode;
  loadData: any;
  saveData?: any;
  createData?: any;
  deleteData?: any;
  title?: string;
  fields: any[];
  sortStateField?: string;
}

export default function TableLeftTemplate(props: TableLeftTemplateProps) {
  return (
    <div className={styles.layoutLeft}>
      <aside className={styles.left}>{props.left}</aside>
      <div className={styles.main}>
        <TableTemplate
          loadData={props.loadData}
          saveData={props.saveData}
          createData={props.createData}
          deleteData={props.deleteData}
          title={props.title}
          fields={props.fields}
          sortStateField={props.sortStateField}
        />
      </div>
    </div>
  );
}